export default __webpack_public_path__ + "static/media/logo.10f21cc2.svg";